(() => {
  if (!location.pathname.includes('/collections/')) return;
  const entry = new URL(location.href);
  const sizeKey = 'filter.v.option.size';
  const sizes = entry.searchParams.getAll(sizeKey);
  const smallerFit = sizes.some(value => /^[0-9]+$/.test(value) && Number(value) >= 70 && Number(value) <= 110);
  if (smallerFit && !sizes.includes('110 - Free Size') && document.querySelector('input[name="filter.v.option.size"][value="110 - Free Size"]')) {
    entry.searchParams.append(sizeKey, '110 - Free Size');
    entry.searchParams.set('dl_fit', '1');
    location.replace(entry.href);
    return;
  }
  let generation = 0;
  let scheduled;
  const sortMode = () => new URL(location.href).searchParams.get('sort_by');
  const shouldShuffle = () => !sortMode() || sortMode() === 'manual';
  const shuffle = (items) => {
    for (let i = items.length - 1; i > 0; i--) {
      const random = new Uint32Array(1); crypto.getRandomValues(random);
      const j = Math.floor((random[0] / 4294967296) * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }
    return items;
  };
  async function refresh() {
    const list = document.querySelector('results-list');
    const grid = list?.querySelector('ul.product-grid');
    if (!grid || grid.dataset.dripRefreshed || !shouldShuffle() || new URL(location.href).searchParams.has('page')) return;
    grid.dataset.dripRefreshed = 'loading';
    const token = ++generation;
    const urlAtStart = location.href;
    const count = Number(grid.dataset.lastPage || 1);
    if (count > 20) { delete grid.dataset.dripRefreshed; return; }
    const sectionId = list.getAttribute('section-id');
    try {
      const pages = [];
      for (let page = 2; page <= count; page++) {
        const url = new URL(urlAtStart); url.searchParams.set('page', page); url.searchParams.set('section_id', sectionId);
        const response = await fetch(url, { signal: AbortSignal.timeout(20000) });
        if (!response.ok) throw new Error('Collection page unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const cards = [...doc.querySelectorAll('results-list ul.product-grid > li[data-product-id]')];
        if (!cards.length) throw new Error('Collection page empty');
        pages.push(...cards);
      }
      if (!grid.isConnected || token !== generation || location.href !== urlAtStart || !shouldShuffle()) return;
      const byId = new Map([...grid.querySelectorAll(':scope > li[data-product-id]'), ...pages].map(card => [card.dataset.productId, card]));
      const cards = shuffle([...byId.values()]);
      list.setAttribute('infinite-scroll', 'false');
      list.querySelectorAll('[ref="viewMoreNext"], [ref="viewMorePrevious"], ' + 'pagination-controls, .pagination').forEach(el => el.remove());
      grid.dataset.lastPage = '1';
      cards.forEach(card => { card.dataset.page = '1'; card.removeAttribute('ref'); });
      grid.replaceChildren();
      let shown = 0;
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'button'; button.textContent = 'Show more';
      button.style.cssText = 'display:block;margin:32px auto';
      button.setAttribute('aria-controls', 'ResultsList');
      const showMore = () => {
        grid.append(...cards.slice(shown, shown + 24)); shown += 24;
        if (shown >= cards.length) button.remove();
      };
      button.addEventListener('click', showMore);
      grid.after(button); showMore(); grid.dataset.dripRefreshed = 'ready';
      grid.dataset.dripTotal = String(cards.length);
    } catch (error) {
      // Retain Shopify's complete native pagination if loading is interrupted.
      delete grid.dataset.dripRefreshed;
      console.warn('Collection refresh retained native ordering', error);
    }
  }
  const observer = new MutationObserver(() => {
    clearTimeout(scheduled); scheduled = setTimeout(refresh, 150);
  });
  observer.observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
})();